import { DATABASE_UPDATE } from "../actions/database";
import buildReducer from "./build-reducer";
import databaseRowsToIdMap from "../database-rows-to-id-map";
import { Map } from "immutable";
import { RACE_SET_IS_SOON } from "../actions/race";

let reducers = {};

reducers[DATABASE_UPDATE] = (state, { tables: { races } }) => {
  if (races === undefined) {
    return state;
  }
  return state.mergeDeep(databaseRowsToIdMap(races));
};
reducers[RACE_SET_IS_SOON] = (state, { raceId }) =>
  state.setIn([raceId, "isSoon"], true);

export default buildReducer(Map(), reducers);
